// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_AtivarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /plano_metas/ativar/{id}
 *
 * No body required — id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface PlanoMetas_AtivarInput {}

registerContract('PlanoMetas_AtivarInput', {})
